import * as Sentry from "@sentry/nextjs";

async function init() {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 1.0,
  });
}

async function captureException(error: unknown) {
  Sentry.captureException(error);
}

async function captureMessage(message: string) {
  Sentry.captureMessage(message);
}

async function captureEvent(event: Sentry.Event) {
  Sentry.captureEvent(event);
}

export const SentryService = Object.freeze({
  captureEvent,
  captureException,
  captureMessage,
  init,
});
